/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-08-07 17:58:17
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, getFormValues } from 'redux-form';
import { FormLayout, Stack } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { RenderSelect } from 'src/components/views/common/forms/render-select';
import { RenderCheckbox } from 'src/components/views/common/forms/render-checkbox';
import { RenderTextField } from 'src/components/views/common/forms/render-textfield';
import {
  FILTER_TREE_SHOW_MORE_TYPE,
  FILTER_TREE_ADVANCED_SORT_TYPE,
  FILTER_TYPE
} from 'src/constants/filter-tree';
import { hasTag, isExceedLength } from 'src/helpers/form-validation-helper';

type Props = WithI18nProps;

const isExceedLengthValue = isExceedLength(119);

class AdvancedTab extends Component<Props, State> {
  componentDidMount() {}

  render() {
    const { displayTooltip, i18n } = this.props;
    const sortType = FILTER_TREE_ADVANCED_SORT_TYPE.map(function (type) {
      return {
        ...type,
        label: i18n.translate(type.label)
      };
    });
    const showMoreType = FILTER_TREE_SHOW_MORE_TYPE.map(function (type) {
      return {
        ...type,
        label: i18n.translate(type.label)
      };
    });

    let { optionType } = this.props;
    optionType =
      optionType && _.startsWith(optionType, FILTER_TYPE.RANGE_SLIDER)
        ? FILTER_TYPE.RANGE_SLIDER
        : optionType;

    const isMultiLevelOption = this.checkIsMultiLevelOption();
    const isDisplayTypeRange = this.checkIsDisplayRange();

    return (
      <FormLayout>
        <Field
          name="displayTooltip"
          component={RenderCheckbox}
          label={i18n.translate('AdminHTML.FilterTree.Item.optionModal_AdvancedTab_Field1_Label')}
        />
        {displayTooltip ? (
          <Field
            name="tooltip"
            component={RenderTextField}
            label={i18n.translate('AdminHTML.FilterTree.Item.optionModal_AdvancedTab_Field2_Label')}
            placeholder={i18n.translate(
              'AdminHTML.FilterTree.Item.optionModal_AdvancedTab_Field2_Placeholder'
            )}
            validate={[hasTag, isExceedLengthValue]}
          />
        ) : (
          ''
        )}

        <Field
          name="displayAllValuesInUppercaseForm"
          component={RenderCheckbox}
          label={i18n.translate('AdminHTML.FilterTree.Item.optionModal_AdvancedTab_Field3_Label')}
          tooltip={i18n.translate(
            'AdminHTML.FilterTree.Item.optionModal_AdvancedTab_Field3_Tooltip'
          )}
        />

        {optionType !== FILTER_TYPE.PRICE &&
        optionType !== FILTER_TYPE.VARIANTS_PRICE &&
        optionType !== FILTER_TYPE.REVIEW_RATINGS &&
        optionType !== FILTER_TYPE.STOCK_STATUS &&
        optionType !== FILTER_TYPE.WEIGHT &&
        optionType !== FILTER_TYPE.RANGE_SLIDER ? (
          <div className="groupFields">
            <Field
              name="sortManualValues"
              component={RenderCheckbox}
              label={i18n.translate(
                'AdminHTML.FilterTree.Item.optionModal_AdvancedTab_Field4_Label'
              )}
              tooltip={i18n.translate(
                'AdminHTML.FilterTree.Item.optionModal_AdvancedTab_Field4_Tooltip'
              )}
            />

            {!isMultiLevelOption ? (
              <Field
                name="sortType"
                component={RenderSelect}
                label={i18n.translate(
                  'AdminHTML.FilterTree.Item.optionModal_AdvancedTab_Field5_Label'
                )}
                options={sortType}
                tooltip={i18n.translate(
                  'AdminHTML.FilterTree.Item.optionModal_AdvancedTab_Field5_Tooltip'
                )}
              />
            ) : (
              ''
            )}

            <Field
              name="showMoreType"
              component={RenderSelect}
              label={i18n.translate(
                'AdminHTML.FilterTree.Item.optionModal_AdvancedTab_Field6_Label'
              )}
              options={showMoreType}
              tooltip={i18n.translate(
                'AdminHTML.FilterTree.Item.optionModal_AdvancedTab_Field6_Tooltip'
              )}
            />
          </div>
        ) : (
          ''
        )}

        {(optionType === FILTER_TYPE.TAG || optionType === FILTER_TYPE.MULTI_LEVEL_TAG) && (
          <Field
            name="useAndCondition"
            component={RenderCheckbox}
            label={i18n.translate('AdminHTML.FilterTree.Item.optionModal_AdvancedTab_Field7_Label')}
            tooltip={i18n.translate(
              'AdminHTML.FilterTree.Item.optionModal_AdvancedTab_Field7_Tooltip'
            )}
          />
        )}

        <Stack distribution="fill">
          <Field
            name="isCollapsePC"
            component={RenderCheckbox}
            label={i18n.translate('AdminHTML.FilterTree.Item.optionModal_AdvancedTab_Field8_Label')}
            tooltip={i18n.translate(
              'AdminHTML.FilterTree.Item.optionModal_AdvancedTab_Field8_Tooltip'
            )}
          />
          <Field
            name="isCollapseMobile"
            component={RenderCheckbox}
            label={i18n.translate('AdminHTML.FilterTree.Item.optionModal_AdvancedTab_Field9_Label')}
            tooltip={i18n.translate(
              'AdminHTML.FilterTree.Item.optionModal_AdvancedTab_Field9_Tooltip'
            )}
          />
        </Stack>

        {!isMultiLevelOption &&
        optionType !== FILTER_TYPE.PRICE &&
        optionType !== FILTER_TYPE.STOCK_STATUS &&
        optionType !== FILTER_TYPE.PERCENT_SALE &&
        !isDisplayTypeRange ? (
          <Stack distribution="fill">
            <Field
              name="showSearchBoxFilterPC"
              component={RenderCheckbox}
              label={i18n.translate(
                'AdminHTML.FilterTree.Item.optionModal_AdvancedTab_Field10_Label'
              )}
              tooltip={i18n.translate(
                'AdminHTML.FilterTree.Item.optionModal_AdvancedTab_Field_ShowSearchBox_Tooltip'
              )}
            />
            <Field
              name="showSearchBoxFilterMobile"
              component={RenderCheckbox}
              label={i18n.translate(
                'AdminHTML.FilterTree.Item.optionModal_AdvancedTab_Field11_Label'
              )}
              tooltip={i18n.translate(
                'AdminHTML.FilterTree.Item.optionModal_AdvancedTab_Field_ShowSearchBox_Tooltip'
              )}
            />
          </Stack>
        ) : (
          ''
        )}
      </FormLayout>
    );
  }

  checkIsMultiLevelOption = () => {
    const { filterOption = {}, optionType } = this.props;
    const { collectionDisplayType } = filterOption;

    return (
      optionType === 'multi_level_tag' ||
      (optionType === 'collection' && collectionDisplayType === 'multi_level_collections')
    );
  };

  checkIsDisplayRange = () => {
    const { filterOption = {}, optionType } = this.props;
    const { variantsPriceDisplayType } = filterOption;
    return (
      (optionType === FILTER_TYPE.VARIANTS_PRICE && variantsPriceDisplayType === 'range') ||
      optionType?.includes(FILTER_TYPE.RANGE_SLIDER) ||
      optionType === FILTER_TYPE.WEIGHT ||
      optionType?.includes(FILTER_TYPE.RANGE_VARIANTS_RANGE_SLIDERLIDER)
    );
  };
}

const mapStateToProps = (state, props) => {
  const formFilterOptionValues = getFormValues('OptionModalForm')(state);

  return {
    displayTooltip: _.get(formFilterOptionValues, 'displayTooltip', ''),
    optionType: _.get(formFilterOptionValues, 'optionType', ''),
    filterOption: formFilterOptionValues
  };
};
export default connect(mapStateToProps)(withI18n()(AdvancedTab));
